import React, { useEffect, useState } from 'react';
import moment from 'utils/moment';
import AllocationScheduler from './Scheduler/AllocationScheduler';

function Gantt(props) {
    const { data, gateSetting, selectionRange } = props;
    const [new_data, setNewData] = useState([]);
    const [gates, setGates] = useState([]);

    useEffect(() => {
        if (data?.length > 0) {
            const change_data = (data || [])?.flatMap((item) => {
                const today = moment(selectionRange.date1).format('YYYY-MM-DD');
                const date = moment(selectionRange.date1).format('d');
                const operationDay = +date === 0 ? 6 : date - 1;
                let isValid = false;

                if (item?.start_date && item?.end_date) {
                    const startDate = new Date(item?.start_date);
                    const endDate = new Date(item?.end_date);
                    const selectedDate = new Date(selectionRange.date1);

                    startDate.setHours(0, 0, 0, 0);
                    endDate.setHours(0, 0, 0, 0);
                    selectedDate.setHours(0, 0, 0, 0);
                    if (startDate <= selectedDate
                        && endDate >= selectedDate
                        && (item.operation_days.includes(operationDay) || item.operation_days.includes(7))
                    ) {
                        isValid = true;
                    }
                } else if (item.operation_days.includes(operationDay) || item.operation_days.includes(7)) {
                    isValid = true;
                }

                if (isValid) {
                    const dateStart = moment(`${today} ${item.schedule_arrival}`).format();
                    const dateEnd = moment(`${today} ${item.schedule_departure}`).format();

                    return [{
                        ...item,
                        dateStart,
                        dateEnd,
                        displayStart: moment(dateStart).format('h:mm A'),
                        displayEnd: moment(dateEnd).format('h:mm A'),
                        label: item?.arrival_flight_number || item?.departure_flight_number,
                        displayText: item?.arrival_flight_number || item?.departure_flight_number,
                        backgroundColor: '#77b51f',
                        planId: item?.gate_key
                    }];
                }
                return [];
            });
            const gates_data = data.map(item => ({ id: item.gate_key, text: item.gate_key, label: item.gate_key }));
            setNewData(change_data);
            setGates((gates_data || [])?.sort((a, b) => a?.text?.localeCompare(b?.text, undefined, { numeric: true, sensitivity: 'base' })));
        } else {
            setNewData([]);
            setGates([]);
        }
    }, [data, selectionRange]);

    const cellDuration = gateSetting?.info?.alloc_setting?.cellTimeDuration || 'halfHour';
    const timeDuration = gateSetting?.info?.alloc_setting?.flightTimeDuration || 60;

    return (
        <AllocationScheduler
            rawEventsData={new_data}
            columnsData={gates}
            timelineDayScale={cellDuration}
            cellDuration={timeDuration}
            disableResize
            disableDrag
            currentTimeIndicator
            dateCurrent={selectionRange.date1}
            groupId="planId"
        />
    );
}

export default Gantt;
